/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<e5b5b3f6e6b406044f63f1c268fcd2dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type heroElementFragment$data = {
  readonly homePageTitle: string | null | undefined;
  readonly userLanguageTag: string | null | undefined;
  readonly visualConfig: {
    readonly foregroundColor: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "heroElementFragment";
};
export type heroElementFragment$key = {
  readonly " $data"?: heroElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "heroElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "homePageTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userLanguageTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "foregroundColor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpLayoutHeroElement",
  "abstractKey": null
};

(node as any).hash = "994a56f0bb806899b30ecbba62200689";

export default node;
